module.exports = __webpack_public_path__ + "img/icon-takeovers_hover.6bd74dc0.svg";